import type { CommunityDetail } from '@pba/react-network';
import { useCallback } from 'react';
import { Modal, type ModalOptions } from 'ui';
import { useRequestToJoinCommunityMutation } from '../../queries';
import { RequestJoinForm, type RequestJoinFormValues } from './request-join-form';

export type RequestJoinModalOptions = {
  community: CommunityDetail;
};

type P = {
  onCancel: () => void;
  onSuccess: () => void;
  options: ModalOptions<RequestJoinModalOptions>;
};

const RequestJoinModal = ({ onCancel, onSuccess, options }: P) => {
  const { isPending: isRequestingToJoinCommunity, mutateAsync: requestToJoinCommunity } =
    useRequestToJoinCommunityMutation();

  const onFinish = useCallback(
    async ({ reason }: RequestJoinFormValues) => {
      if (!options.isOpened) {
        return;
      }

      await requestToJoinCommunity({ id: options.community.id, reason });
      onSuccess();
    },
    [onSuccess, options, requestToJoinCommunity],
  );

  return (
    <Modal isOpened={options.isOpened} onCancel={onCancel} title="Request to Join" width="medium">
      {options.isOpened ? (
        <Modal.HugContent>
          <RequestJoinForm isLoading={isRequestingToJoinCommunity} onCancel={onCancel} onFinish={onFinish} />
        </Modal.HugContent>
      ) : null}
    </Modal>
  );
};

export default RequestJoinModal;
